import { Box } from '@material-ui/core';

import { AuthorizationTypeMap } from '@/components/modules/Webhooks/maps/authorizationType.map';
import { AuthorizationType } from '@/components/modules/Webhooks/schemas/AuthorizationType';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';

export const AUTHORIZATION_TYPE_SELECT_OPTIONS = Object.values(AuthorizationType).map((value) => ({
  value,
  display: (
    <Box display={'flex'} alignItems={'center'}>
      <Icon size={18}>{AuthorizationTypeMap.toIcon(value)}</Icon>
      <Box style={{ marginLeft: '8px' }}>
        <Text tId={`AuthorizationType_${value}`} />
      </Box>
    </Box>
  ),
}));
